import { getTextStyles } from '@braskai/ui-kit';

import { css, InputLabel, styled } from '@mui/material';

export const SInputLabel = styled(InputLabel)(
  ({ theme }) => css`
    color: ${theme.palette.grey[700]};
    ${getTextStyles('body-2-md')}
  `,
);
